import { HelpCircle, RotateCcw } from "lucide-react";

/**
 * De-emphasised Priority field used across Assignment Rules, Coverage Policies,
 * Leave Rules and Fairness Rules editors. Visually secondary, fully functional.
 *   - Small slate label, current value shown inline
 *   - Narrow input
 *   - "?" tooltip with the standard helper
 *   - "Reset" link visible only when value ≠ default (100)
 */
export default function PriorityOrderField({ value, onChange, testid, defaultValue = 100 }) {
  const v = Number(value) || defaultValue;
  const isDefault = v === defaultValue;
  return (
    <div data-testid={testid ? `${testid}-wrap` : "priority-order-wrap"}>
      <div className="flex items-center gap-1.5">
        <label className="text-[11px] uppercase tracking-widest text-[#64748B]">
          Priority order ({v})
        </label>
        <span
          title="Lower numbers are evaluated first. 1 = highest priority, 1000 = lowest priority."
          className="inline-flex items-center text-[#94A3B8] hover:text-[#475569] cursor-help"
          data-testid={testid ? `${testid}-tip` : "priority-order-tip"}>
          <HelpCircle className="h-3.5 w-3.5" />
        </span>
        {!isDefault && (
          <button type="button"
            onClick={() => onChange(defaultValue)}
            data-testid={testid ? `${testid}-reset` : "priority-order-reset"}
            className="ml-auto inline-flex items-center gap-0.5 text-[10px] text-[#2563EB] hover:underline">
            <RotateCcw className="h-2.5 w-2.5" />Reset
          </button>
        )}
      </div>
      <input
        type="number" min="1" max="1000"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        data-testid={testid || "priority-order"}
        className="mt-1 h-9 w-20 px-2 text-sm rounded-md border border-slate-200 bg-slate-50 text-[#1F2A44] focus:outline-none focus:ring-1 focus:ring-[#2563EB]" />
    </div>
  );
}
